import { render, staticRenderFns } from "./CustomerBookingView.vue?vue&type=template&id=247e635b&"
import script from "./CustomerBookingView.vue?vue&type=script&lang=js&"
export * from "./CustomerBookingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports